import get from 'lodash/get';
import { createReducerContext } from '../../utils/createReducerContext';

export const ATTACHMENT_UPLOAD_STATUS = {
  inProgress: 'IN_PROGRESS',
  finished: 'FINISHED',
  idle: 'IDLE',
};

export const CONVERSION_STATUS = {
  finished: 'COMPLETED',
  timedOut: 'FAILED',
  inProgress: 'IN_PROGRESS',
  idle: 'IDLE',
};

export const ATTACHMENT_CONTEXT_ACTIONS = {
  conversionStatusChange: 'CONVERSION_STATUS_CHANGE',
  updateAttachment: 'UPDATE_ATTACHMENT',
  finishedUploading: 'FINISHED_UPLOADING',
  removeAttachment: 'REMOVE_ATTACHMENT',
  startedUploading: 'STARTED_UPLOADING',
  uploadError: 'UPLOAD_ERROR',
};

export const attachmentContextInitialState = {
  uploadStatus: ATTACHMENT_UPLOAD_STATUS.idle,
  conversionStatus: CONVERSION_STATUS.idle,
  attachment: null,
  fileType: null,
  uploadError: null,
};

function reducer(state, action) {
  switch (action.type) {
    case ATTACHMENT_CONTEXT_ACTIONS.conversionStatusChange: {
      return {
        ...state,
        conversionStatus:
          get(action.payload, 'status') || CONVERSION_STATUS.finished,
      };
    }
    case ATTACHMENT_CONTEXT_ACTIONS.removeAttachment:
      return {
        ...state,
        attachment: null,
        uploadStatus: ATTACHMENT_UPLOAD_STATUS.idle,
        conversionStatus: CONVERSION_STATUS.idle,
        uploadError: null,
      };
    case ATTACHMENT_CONTEXT_ACTIONS.finishedUploading: {
      const { taskInfo, ...attachment } = action.payload;
      return {
        ...state,
        attachment,
        uploadStatus: ATTACHMENT_UPLOAD_STATUS.finished,
        conversionStatus: get(taskInfo, 'status') || CONVERSION_STATUS.finished,
      };
    }
    case ATTACHMENT_CONTEXT_ACTIONS.startedUploading: {
      return {
        ...state,
        fileType: action.payload,
        uploadStatus: ATTACHMENT_UPLOAD_STATUS.inProgress,
      };
    }
    case ATTACHMENT_CONTEXT_ACTIONS.updateAttachment:
      return {
        ...state,
        attachment: action.payload,
      };

    case ATTACHMENT_CONTEXT_ACTIONS.uploadError:
      return {
        ...state,
        uploadError: action.payload,
      };
    default:
      // eslint-disable-next-line no-console
      console.error('Unsupported action of attachmentContextReducer');
      return state;
  }
}

export const {
  ReducerProvider: AssignmentAttachmentContextProvider,
  useReducerDispatch: useAssignmentAttachmentDispatch,
  useReducerState: useAssignmentAttachmentState,
} = createReducerContext(
  'AssignmentAttachment',
  reducer,
  attachmentContextInitialState,
);
